import { request, requestWithPlanWarning } from '@/api/http';
import type { Source, SourceHealth, SourceTestResult } from '@/api/types';

export const sourcesService = {
  list: () => request<Source[]>('/sources'),
  health: () => request<SourceHealth[]>('/sources/health'),
  create: async (body: object) => {
    const { data, planWarning } = await requestWithPlanWarning<Source>('/sources', {
      method: 'POST',
      body: JSON.stringify(body),
    });
    return { data, planWarning };
  },
  update: async (id: string, body: object) => {
    const { data, planWarning } = await requestWithPlanWarning<Source>(`/sources/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    });
    return { data, planWarning };
  },
  delete: (id: string) => request<void>(`/sources/${id}`, { method: 'DELETE' }),
  test: (id: string, body: { test_url?: string; search_text?: string; limit?: number }) =>
    request<SourceTestResult>(`/sources/${id}/test`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
